import * as React from 'react'
import styled from 'styled-components'
import I18n from 'core/i18n'
import * as constants from 'static/constants'
import ReactSelect from 'react-select'
import moment from 'moment'
import { YearMonthPicker } from 'components/atoms/YearMonthPicker'

interface IProps {
  selectedMonth: moment.Moment
  onMonthChange: (month: moment.Moment) => void
  selectedPostType: string | null
  onPostTypeChange: (postType: string | null) => void
  selectedRequestStatuses: string[]
  onRequestStatusesChange: (statuses: string[]) => void
  allRequestStatuses: Record<string, number>
}

const GuideAssignmentFilter: React.FC<IProps> = ({
  selectedMonth,
  onMonthChange,
  selectedPostType,
  onPostTypeChange,
  selectedRequestStatuses,
  onRequestStatusesChange,
  allRequestStatuses,
}) => {
  const handlePostTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value
    onPostTypeChange(value === '' ? null : value)
  }

  const handleRequestStatusChange = selectedOptions => {
    onRequestStatusesChange(selectedOptions ? selectedOptions.map(option => option.value) : [])
  }

  return (
    <FilterContainer>
      <FilterGroup>
        <Label>月選択</Label>
        <YearMonthPicker defaultValue={selectedMonth} handleChange={onMonthChange} />
      </FilterGroup>

      <FilterGroup>
        <Label>ツアータイプ</Label>
        <Select value={selectedPostType || ''} onChange={handlePostTypeChange}>
          <option value="">{I18n.t('generic.all')}</option>
          <option value="private">{I18n.t('post.private_tour')}</option>
          <option value="group">{I18n.t('post.group_tour')}</option>
        </Select>
      </FilterGroup>

      <FilterGroup>
        <Label>リクエストステータス</Label>
        <ReactSelect
          isMulti={true}
          options={Object.entries(allRequestStatuses).map(([status, label]) => ({
            value: status,
            label,
          }))}
          value={selectedRequestStatuses.map(status => ({
            value: status,
            label: allRequestStatuses[status],
          }))}
          onChange={handleRequestStatusChange}
        />
      </FilterGroup>
    </FilterContainer>
  )
}

const FilterContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
`

const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
`

const Label = styled.label`
  font-weight: bold;
  margin-bottom: 8px;
  color: ${constants.COLORS.primary};
  font-size: 14px;
`

const Select = styled.select`
  padding: 8px 12px;
  border: 1px solid ${constants.COLORS.divider2};
  border-radius: 4px;
  font-size: 14px;
  background-color: white;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: ${constants.COLORS.primary};
  }

  &:disabled {
    cursor: not-allowed;
    background-color: ${constants.COLORS.lightGray};
    opacity: 0.6;
  }
`

export default GuideAssignmentFilter
